// @ts-strict-ignore
import {formatUserProperties, getRawPropertyName} from 'common/util/format-property';
import {MPProperties} from 'common/constants';
import {checkProfileExists, getUserPropertiesFromApiResult} from 'common/report/util/profile/utils';
import type {
  AliasesQueryResult,
  EngageQueryResult,
  FormattedAliasesResult,
  FormattedEngageResult,
} from 'common/report/util/profile/types';
import {LocalizationStore} from 'common/i18n/store';

export function engageResultFormatter({
  engageQueryResult,
  dataGroupId,
  timezone,
  i18n,
  propertyToScdEvent = null,
}: {
  engageQueryResult: EngageQueryResult;
  dataGroupId: string;
  timezone: string;
  i18n: LocalizationStore;
  propertyToScdEvent?: Record<string, string>;
}): FormattedEngageResult {
  const {error, results} = engageQueryResult;
  if (error || results.status !== `ok`) {
    return {
      error: true,
      results: null,
      messages: null,
      profileExists: false,
    };
  }

  const properties = getUserPropertiesFromApiResult(results);

  const formattedProperties = formatUserProperties(properties, {timezone, dataGroupId, i18n});
  const messages = properties[MPProperties.Campaigns] as string[];
  const profileExists = checkProfileExists(results);

  if (propertyToScdEvent && Object.keys(propertyToScdEvent).length > 0) {
    formattedProperties.forEach((property) => {
      const propertyName = getRawPropertyName(property);
      const scdEvent = propertyToScdEvent[propertyName];
      if (scdEvent) {
        property.renderValue.scdEvent = scdEvent;
      }
    });
  }

  return {
    error: false,
    results: formattedProperties,
    profileExists,
    messages,
  };
}

export function aliasesResultFormatter(result: AliasesQueryResult): FormattedAliasesResult {
  const {results, error} = result;
  if (!error) {
    const {aliases, resolves_to: resolvesTo} = results;
    return {
      aliases,
      error: false,
      resolvesTo,
    };
  }
  return {
    aliases: [],
    error: true,
    resolvesTo: null,
  };
}
